import { createStore } from "vuex";

const timeout = 10000;

class ToastMessage {
    constructor(message, icon, ttl, classes) {
        this.message = message;
        this.icon = icon
        this.createdAt = Date.now()
        this.ttl = ttl || timeout
        this.classese = classes || ""
    }
}

const store = createStore({
    state: {
        messages: {},
        generalClasses: ""
    },
    mutations: {
        ADD(state, toastMessage) {
            if (toastMessage.message) {
                state.messages[toastMessage.createdAt] = toastMessage;
            }
        },
        REMOVE(state, key) {
            if (key) {
                delete state.messages[key];
            }
        }
    },
    actions: {
        addMessage(context, message) {
            if (!message || !message.message) return;

            // Check if an identical message and icon is already displayed in active messages
            const existingMessage = Object.values(context.state.messages).find(
                m => m.message === message.message && m.icon === message.icon
            );
            if (existingMessage) {
                // If it already exists, do not stack another copy
                return;
            }

            const toastMessage = new ToastMessage(message.message, message.icon, message.ttl, message.classes)
            context.state.generalClasses = message.classes || ""
            context.commit("ADD", toastMessage)
            if (message.ttl === -1) {
                return;
            }
            setTimeout(() => {
                context.commit("REMOVE", toastMessage.createdAt)
            }, toastMessage.ttl)
        },
        removeMessage(context, key) {
            context.commit("REMOVE", key)
        }
    }
})

export default store;